const SCRIPT_BLOCK = /<script[\s\S]*?>[\s\S]*?<\/script>/gi;
const STYLE_BLOCK = /<style[\s\S]*?>[\s\S]*?<\/style>/gi;
const EVENT_HANDLER = /\son[a-z]+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi;
const JS_PROTOCOL = /(href|src)\s*=\s*(['"])\s*javascript:[^'"]*\2/gi;

/** Sanitização básica para HTML de e-mail/API no desk (sem DOMPurify). */
export function sanitizeSupportHtml(html: string): string {
  return html
    .replace(SCRIPT_BLOCK, '')
    .replace(STYLE_BLOCK, '')
    .replace(EVENT_HANDLER, '')
    .replace(JS_PROTOCOL, '$1=$2#$2')
    .replace(/\ssrc\s*=\s*(['"])\s*cid:[^'"]*\1/gi, ' src=$1data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7$1');
}

export function looksLikeHtml(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) {
    return false;
  }

  return /<!DOCTYPE\s+html/i.test(trimmed)
    || /<\/?(html|head|body|table|div|span|p|br|a|img|font|center)\b/i.test(trimmed)
    || /<\/?[a-z][\w:-]*\b[^>]*>/i.test(trimmed);
}

export function looksLikeMarkdown(value: string): boolean {
  return /(^|\n)\s{0,3}#{1,6}\s|(^|\n)\s*[-*+]\s+\S|(^|\n)\s*\d+\.\s+\S|\*\*[^*]+\*\*|__[^_]+__|`[^`]+`|\[[^\]]+\]\([^)]+\)/m
    .test(value);
}

export function isBlankHtml(html: string): boolean {
  const normalized = html.replace(/<p><br\s*\/?><\/p>/gi, '').replace(/<p>\s*<\/p>/gi, '').trim();
  return !normalized || normalized === '<br>' || normalized === '<br/>';
}
